import React from 'react';
import classes from './OptionsDropdown.module.css';

const optionsDropdown = (props) => {
  const containerClasses = [classes.OptionsDropdownContainer];
  if (props.className) containerClasses.push(classes[props.className]);
  return (
    <div className={containerClasses.join(' ')}>
      {props.headerText ? <p className={classes.Header}>{props.headerText}</p> : null}
      {props.options.map((option, i) => (
        <p name={option.name} key={i} onClick={option.action} className={classes.Option}>
          {option.text}
        </p>
      ))}
    </div>
  );
};

export default optionsDropdown;
